import { PublisherData } from "../entity/publisher/PublisherData"
import { Roles } from "../../constants/roles"

export type AuthContextData = {
  id: number
  email: string
  name: string
  surname: string
  role: Roles[]
  active: boolean
  pub_consents_compiled: boolean
  publishers?: PublisherData[]
}

export function extendAuthContext(user: AuthContextData) {
  return {
    ...user,
    hasSuperuserAccess(): boolean {
      return user.role.includes(Roles.Superuser) || user.role.includes(Roles.Admin) || user.role.includes(Roles.Chosen)
    },
    isPublisher(): boolean {
      return user.role.includes(Roles.Pub)
    },
    isAdmin(): boolean {
      return user.role.includes(Roles.Admin)
    },
    hasChosenAccess(): boolean {
      return user.role.includes(Roles.Chosen) || user.role.includes(Roles.Admin)
    },
  }
}
